import { CircleUserIcon, Folder, Settings } from 'lucide-react'
import { useParams } from 'react-router'

import { SidebarItem } from '@/components/sidebar/types'
import { useSession } from '@/contexts/auth/session'
import useTranslator from '@/hooks/translation'
import { useUserQuery } from '@/hooks/user/use-user-query'

export const useMenuItems = (): SidebarItem[] => {
  const { data: user } = useUserQuery()
  const {
    state: { isUserAuthenticated },
  } = useSession()

  const isAdminMember = !!user.is_admin
  const isRootUser = !!user.is_root

  const params = useParams()
  const { getTranslation } = useTranslator()

  const companyId = params.companyId!

  return [
    {
      index: 0,
      icon: <Folder />,
      title: getTranslation('common.projects'),
      path: `/companies/${companyId}/projects`,
      disabled: !isUserAuthenticated,
      hidden: false,
    },
    {
      index: 1,
      icon: <CircleUserIcon />,
      title: getTranslation('members.text'),
      path: `/companies/${companyId}/members`,
      disabled: !isUserAuthenticated,
      hidden: false,
    },
    {
      index: 3,
      icon: <Settings />,
      title: getTranslation('companies.settings'),
      path: `/companies/${companyId}/settings`,
      disabled: !isUserAuthenticated,
      hidden: !isAdminMember && !isRootUser,
    },
  ]
}
